import React, { Component } from 'react';
import * as actions from '../../store/actions/index';
import IdleTimer from 'react-idle-timer';
import { connect } from 'react-redux';


class SessionIdleTimer extends Component {

    onActive = (e) => {
        this.idleTimer.pause();
      }

    onIdle = (e) => {
        this.onChangeStage(12);
    }

    onChangeStage = (stage) => {
        this.props.onChangeStage(stage);
    }
    
    componentWillUnmount(){
        this.idleTimer.pause();
    }

    componentDidMount() {
        this.idleTimer.reset();
    }

    componentDidUpdate(prevProps, previousState) {
        this.idleTimer.reset();
    }

    render() {
        const sessionIdleTime = localStorage.getItem('sessionTime');
        return (
            <>
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onActive={this.onActive}
                    onIdle={this.onIdle}
                    debounce={250}
                    stopOnIdle={true}
                    timeout={sessionIdleTime?(1000  * 60 * parseInt(sessionIdleTime)):1000*60*10}
                />
            </>
        );
    }
}

const mapDispatchToProps = dispatch => {

    return {
        onChangeStage: (stage) => dispatch(actions.stageUpdate(stage)),
    }
}

export default connect(null, mapDispatchToProps)(SessionIdleTimer);